import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconPrice(rest) {
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        fill="none"
        d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
      />
    </Icon>
  )
}
